module.exports = __webpack_public_path__ + "static/media/Neo-Bank-App-08.d257bbf0.png";